const FAVICON_FRAMES = [
  '/favicon-p1-32x32.png',
  '/favicon-p2-32x32.png',
  '/favicon-p3-32x32.png',
  '/favicon-p4-32x32.png',
  '/favicon-p5-32x32.png'
] as const

const FRAME_MS = 1000

function getIconLinks () {
  const links = Array.from(document.querySelectorAll<HTMLLinkElement>(
    'link[rel="icon"], link[rel="shortcut icon"]'
  ))

  if (links.length > 0) return links

  const link = document.createElement('link')
  link.rel = 'icon'
  link.type = 'image/png'
  link.sizes = '32x32'
  document.head.appendChild(link)

  return [link]
}

function setFrame (links: HTMLLinkElement[], src: string, tick: number) {
  const href = `${src}?f=${tick}`

  for (const link of links) {
    link.type = 'image/png'
    link.href = href
  }
}

export function animateFavicon (options?: { frameMs?: number }) {
  const frameMs = options?.frameMs ?? FRAME_MS
  const links = getIconLinks()
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

  setFrame(links, FAVICON_FRAMES[0], 0)

  if (reducedMotion) return () => {}

  let frameIndex = 0
  let tick = 0

  const intervalId = window.setInterval(() => {
    frameIndex = (frameIndex + 1) % FAVICON_FRAMES.length
    tick += 1
    setFrame(links, FAVICON_FRAMES[frameIndex], tick)
  }, frameMs)

  return () => window.clearInterval(intervalId)
}
